/* need for old browsers without defer */
import { renderYoutubeWidgetWithScript } from './modules/youtube-subscribe.js';
import { addEventsOnShareButtons } from './modules/sharing.js';
import { initEmbeds } from './modules/embeds/index.js';
import { observeLazySources } from './modules/lazy-sources-loader.js';
import { initGallery } from './modules/gallery.js';
import { getNewLiveUpdates } from './services/api.js';

const UPDATE_INTERVAL = 15000;

const CLASSES = {
  liveBlock: `.js-live-block`,
  liveBlocksContainer: `.js-live-blocks-container`,
  liveTab: `.js-live-tab`,
  sortButton: `.js-sort-btn`,
  updateButton: `.js-update-btn`,
  article: `.js-article`,
  liveBlocksCount: `.js-live-blocks-count`,
  liveTime: `.js-live-time`,
  livePlot: `.js-live-plot`,
  liveEnded: `.js-live-ended`,
};

document.addEventListener(
  `DOMContentLoaded`,
  () => {
    if (window.Site.youTubeChannelId) {
      renderYoutubeWidgetWithScript(
        document,
        { channelid: window.Site.youTubeChannelId },
        `c-article__ytsubscribe--show`,
      );
    }

    const $liveBlocksContainer = document.querySelector(CLASSES.liveBlocksContainer);
    let $liveBlocks = document.querySelectorAll(CLASSES.liveBlock);
    const $liveBlocksCount = document.querySelector(CLASSES.liveBlocksCount);
    const $liveTabs = document.querySelectorAll(CLASSES.liveTab);
    const $sortButton = document.querySelector(CLASSES.sortButton);
    const $updateButton = document.querySelector(CLASSES.updateButton);
    const $article = document.querySelector(CLASSES.article);
    const $liveTime = document.querySelector(CLASSES.liveTime);
    const $livePlot = document.querySelector(CLASSES.livePlot);
    const $liveEnded = document.querySelector(CLASSES.liveEnded);
    let sortAsc = true; // toggle ascending/descending
    let newArticleData = null;
    let latestTimestamp = Math.max(
      ...Array.from($liveBlocks, (node) => Number(node.dataset.timestamp)),
    );

    if ($article) {
      addEventsOnShareButtons($article);
      initGallery($article);
      initEmbeds($article);
    }

    // Init tabs menu functionality
    $liveTabs.forEach(($tab) => {
      $tab.addEventListener(`click`, () => {
        $liveTabs.forEach((t) => t.classList.remove(`live__tab--active`));
        $tab.classList.add(`live__tab--active`);

        const tabId = $tab.dataset.tabId;
        $liveBlocksCount.innerHTML = $tab.dataset.label;

        $liveBlocks.forEach((liveBlock) => {
          if (tabId === `all` || liveBlock.dataset.tabId === tabId) {
            liveBlock.style.display = ``;
          } else {
            liveBlock.style.display = `none`;
          }
        });
      });
    });

    const changeTabsAppearance = () => {
      $liveTabs.forEach(($liveTab) => {
        const liveTabId = $liveTab.dataset.tabId;

        const newTabData = newArticleData.tabs.find((obj) => String(obj.id) === liveTabId);

        if (newTabData) {
          $liveTab.dataset.label = newTabData.label;
        }

        if (liveTabId === `all`) {
          $liveTab.click();
        }

        newTabData
          ? $liveTab.classList.remove(`live__tab--hidden`)
          : $liveTab.classList.add(`live__tab--hidden`);
      });
    };

    // Init sort button
    $sortButton.addEventListener(`click`, () => {
      const sortBlocks = Array.from($liveBlocks);

      sortBlocks.sort((a, b) => {
        const timeA = Number(a.dataset.timestamp);
        const timeB = Number(b.dataset.timestamp);
        return sortAsc ? timeA - timeB : timeB - timeA;
      });

      sortBlocks.forEach((block) => $liveBlocksContainer.append(block));

      sortAsc = !sortAsc;
      sortAsc
        ? $sortButton.classList.remove(`live__sort-btn--chevron-rotate`)
        : $sortButton.classList.add(`live__sort-btn--chevron-rotate`);
    });

    // Init articles update
    $updateButton.addEventListener(`click`, () => {
      $updateButton.style.display = `none`;

      // Update sort btn
      sortAsc = true;
      $sortButton.classList.remove(`live__sort-btn--chevron-rotate`);

      // Update tabs
      changeTabsAppearance();

      // Update article time
      $liveTime.innerHTML = newArticleData.liveTimeView;

      // Update content (article blocks)
      $liveBlocksContainer.innerHTML = newArticleData.contentView;
      $liveBlocks = document.querySelectorAll(CLASSES.liveBlock);
      initEmbeds($liveBlocksContainer);

      // Update plot
      $livePlot.innerHTML = newArticleData.plotView;

      // Update ended block
      if (newArticleData.isEnded) {
        $liveEnded.innerHTML = newArticleData.endedView;
      }
    });

    const updateArticleData = (data) => {
      newArticleData = data;
      latestTimestamp = data.lastUpdatedTime;
      $updateButton.style.display = ``;
    };

    // Interval with ajax request to get new live article data
    const articleIsEnded = Number($article.dataset.endedStatus);

    if (!articleIsEnded) {
      const updateInterval = setInterval(async () => {
        const newData = await getNewLiveUpdates(window.Site.entity_id).then((response) => {
          if (response.status === 200) {
            return response.json();
          }

          return null;
        });

        if (newData && newData.lastUpdatedTime > latestTimestamp) {
          updateArticleData(newData);
        }

        if (newData.isEnded) {
          clearInterval(updateInterval);
        }
      }, UPDATE_INTERVAL);
    }

    /* initialization of lazy loading */
    observeLazySources();
  },
  false,
);
